import { BaseResponseHttp } from './commons.model';
import {
  CallPlace,
  IProducts,
  NotificationErrorType,
} from './myActivity.model';
import { BooleanCons, NumberCons, StringConst, Default } from '../../constants/const';
import { TaxData, DeliveredDirections } from '../../model/http/profile.model';

export class IShoppingProducts extends BaseResponseHttp {
  response?: IShoppingList;
}

export interface IOrderResumeRes extends BaseResponseHttp {
  response: IOrderResume;
}
export class IShoppingProductsDeliveryAndTax extends BaseResponseHttp {
  response?: DataDeliveryAndTax;
}
export class IValidateLabel extends BaseResponseHttp {
  response?: ValidateLabel;
}

export class IValidateMagistralProducts extends BaseResponseHttp {
  response?: string[];
}

export class ValidateLabel {
  productsContainerError: ItemValidateLabel[];
  productsLabelError: ItemValidateLabel[];
  missingItems: MissingItems[];
  productsError: ProductsError[];
  labelErrorQuantity: ItemValidateLabel[];
  missingPtItems: MissingPTItem[];
  productsMaxPieces: ProductMaxPieces[];
  productsMinPieces: ProductMinPieces[];
  constructor() {
    this.productsContainerError = [];
    this.productsLabelError = [];
    this.missingItems = [];
    this.productsError = [];
    this.labelErrorQuantity = [];
    this.missingPtItems = [];
    this.productsMaxPieces = [];
    this.productsMinPieces = [];
  }
}
export class ProductMaxPieces {
  itemCode = StringConst.empty;
  periodDays = 0;
  maxPieces = 0;
  freePieces = 0;
}
export class ProductMinPieces {
  itemCode = StringConst.empty;
  minPieces = 0;
  selectedPieces = 0;
}
export class MissingPTItem {
  userId: string;
  itemCode: string;
  requestedQuantity: number;
  container: string;
  label: string;
  cartType: number;
  isPackage: boolean;
  piecesAvalibaleToSell: number;
  transactionId: string;
  constructor() {
    this.userId = StringConst.empty;
    this.itemCode = StringConst.empty;
    this.requestedQuantity = NumberCons.zero;
    this.container = StringConst.empty;
    this.label = StringConst.empty;
    this.cartType = NumberCons.zero;
    this.isPackage = BooleanCons.false;
    this.piecesAvalibaleToSell = NumberCons.zero;
    this.transactionId = StringConst.empty;
  }
}

export class RemainingDialogConfig {
  changeValuesInShoppingCar: boolean;
  products: MissingPTItem[];
  transactionId: string;
  keyStorage: string;
  informationText: TextsInformation;
  constructor() {
    this.changeValuesInShoppingCar = BooleanCons.false;
    this.products = [];
    this.transactionId = StringConst.empty;
    this.keyStorage = StringConst.empty;
    this.informationText = new TextsInformation();
  }
}

export class TextsInformation {
  titleLegend: string;
  subtitleLegend: string;
  constructor() {
    this.titleLegend = StringConst.empty;
    this.subtitleLegend = StringConst.empty;
  }
}

export class ProductsError {
  itemCode: string;
  description: string;
  container: string;
  label: string;
  constructor() {
    this.itemCode = StringConst.empty;
    this.description = StringConst.empty;
    this.container = StringConst.empty;
    this.label = StringConst.empty;
  }
}

export class MissingItems {
  itemCode: string;
  itemCodeHasMissing: boolean;
  containerHasMissing: boolean;
  arriveDateProduct: Date;
  arriveDateContainer: Date;
  description: string;
  container: string;
  isLine: string;
  isPackage: boolean;
  label: string;
  constructor() {
    this.itemCode = StringConst.empty;
    this.itemCodeHasMissing = BooleanCons.false;
    this.containerHasMissing = BooleanCons.false;
    this.arriveDateProduct = new Date();
    this.arriveDateContainer = new Date();
    this.description = StringConst.empty;
    this.container = StringConst.empty;
    this.isLine = StringConst.empty;
    this.isPackage = BooleanCons.false;
    this.label = StringConst.empty;
  }
}
export class ItemValidateLabel {
  label: string;
  itemCode: string;
  container: string;
  description: string;
  constructor() {
    this.label = StringConst.empty;
    this.itemCode = StringConst.empty;
    this.container = StringConst.empty;
    this.description = StringConst.empty;
  }
}
export class ItemValidateLabelNotification {
  productsLabelError: ItemValidateLabel[];
  callPlace: CallPlace;
  notificationType: NotificationErrorType;
  invalidLabelToContainer: boolean;
  constructor() {
    this.callPlace = CallPlace.default;
    this.productsLabelError = [];
    this.notificationType = NotificationErrorType.default;
    this.invalidLabelToContainer = BooleanCons.false;
  }
}
export class IOrderResume {
  prescritionInfoHeader: PrescritionInfoHeader;
  academicInfo: AcademicInfoResume[];
  totalPrescriptions: number;
  signatureUrl: string;
  constructor() {
    this.prescritionInfoHeader = new PrescritionInfoHeader();
    this.academicInfo = [];
    this.totalPrescriptions = NumberCons.zero;
    this.signatureUrl = StringConst.empty;
  }
}
export class PrescritionInfoHeader {
  doctorName: string;
  cellPhone: string;
  phoneNumber: string;
  zipCode: string;
  state: string;
  municipality: string;
  neighborhood: string;
  street: string;
  streetNumber: string;
  specialityGroup: string;
  alias: string;
  constructor() {
    this.doctorName = StringConst.empty;
    this.cellPhone = StringConst.empty;
    this.phoneNumber = StringConst.empty;
    this.zipCode = StringConst.empty;
    this.state = StringConst.empty;
    this.municipality = StringConst.empty;
    this.neighborhood = StringConst.empty;
    this.street = StringConst.empty;
    this.streetNumber = StringConst.empty;
    this.specialityGroup = StringConst.empty;
    this.alias = StringConst.empty;
  }
}

export class AcademicInfoResume {
  degreeType: string;
  license: string;
  institution: string;

  constructor() {
    this.degreeType = StringConst.empty;
    this.license = StringConst.empty;
    this.institution = StringConst.empty;
  }
}

export class IShoppingList {
  amountTotal: number;
  totalProducts: number;
  totalPieces: number;
  subTotal: number;
  tax: number;
  items: IProducts[];
  cartNeedPrescription: boolean;
  totalOfUtilities: number;
  discount: number;
  shippingCost: number;
  cartContentType: CartContentType;
  hasDiscountSpecial: boolean;
  percentDiscountSpecial: number;
  discountMessages: string[];
  inactiveDays: number;
  inactiveHours: number;
  inactiveMinutes: number;
  typeOrder: string;
  promotionalCodeAmount: number;
  shippingCostDiscountPercent: number;
  validShippingTypes: string[];
  shippingDiscountType: ShippingDiscountType;
  shippingDiscountValue: number;
    constructor() {
    this.subTotal = NumberCons.zero;
    this.totalOfUtilities = NumberCons.zero;
    this.items = [];
    this.cartNeedPrescription = false;
    this.discount = NumberCons.zero;
    this.shippingCost = NumberCons.zero;
    this.cartContentType = CartContentType.default;
    this.hasDiscountSpecial = BooleanCons.false;
    this.percentDiscountSpecial = NumberCons.zero;
    this.amountTotal = NumberCons.zero;
    this.totalProducts = NumberCons.zero;
    this.totalPieces = NumberCons.zero;
    this.tax = NumberCons.zero;
    this.discountMessages = [];
    this.inactiveDays = NumberCons.zero;
    this.inactiveHours = NumberCons.zero;
    this.inactiveMinutes = NumberCons.zero;
    this.typeOrder = StringConst.empty;
    this.promotionalCodeAmount = NumberCons.zero;
    this.shippingCostDiscountPercent = NumberCons.zero;
    this.validShippingTypes = [];
    this.shippingDiscountType = ShippingDiscountType.default;
    this.shippingDiscountValue = NumberCons.zero;
  }
}
export enum CartContentType {
  onlyPackages = 1,
  onlyProducts = 2,
  packagesAndProducts = 3,
  default = 0,
}

export enum ShippingDiscountType {
  monto = 'Monto',
  porcentaje = 'Porcentaje',
  default = '',
}

export const CartContentTypeCompare = {
  onlyPackages: 1,
  onlyProducts: 2,
  packagesAndProducts: 3,
  default: 0,
};

export class DataDeliveryAndTax {
  invoiceInfo?: TaxData;
  addressInfo?: DeliveredDirections;
}
export class IMoreProductsResponse extends BaseResponseHttp {
  response?: IMoreProducts[];
}

export class IMoreProducts {
  itemCode: string;
  quantity: number;
  lastUpdateDate: Date;
  itemAttributes: ItemAttributes[];
  constructor() {
    this.itemCode = StringConst.empty;
    this.quantity = NumberCons.zero;
    this.lastUpdateDate = new Date();
    this.itemAttributes = [];
  }
}
export class ItemAttributes {
  quantity: number;
  container: string;
  label: string;
  itemGrouper: string;
  constructor() {
    this.quantity = NumberCons.zero;
    this.container = StringConst.empty;
    this.label = StringConst.empty;
    this.itemGrouper = StringConst.empty;
  }
}
export class ITotalProductsResponse extends BaseResponseHttp {
  response?: CartCount[];
}

export class CartCount {
  cardCode: string;
  pieces: number;
  typeCart: number;
  constructor() {
    this.cardCode = StringConst.empty;
    this.pieces = NumberCons.zero;
    this.typeCart = NumberCons.zero;
  }
}
export class IProductUpdatedResponse extends BaseResponseHttp {
  response?: [ProductUpdatedFavourite];
}

export class ProductUpdatedFavourite {
  itemCode: string;
  isFavorite: boolean;
  constructor() {
    this.itemCode = StringConst.empty;
    this.isFavorite = false;
  }
}
export interface ShopAgain {
  items: RepurchaseProduct[];
  priceListId: number;
  clientType: string;
}

export class RepurchaseProduct {
  itemCode: string;
  container: string;
  label: string;
  quantity: number;
  isLine: string;
  isPackage: boolean;
  isOrderPackage: boolean;
  userId: string;
  cartType: number;
  constructor() {
    this.itemCode = StringConst.empty;
    this.container = StringConst.empty;
    this.label = StringConst.empty;
    this.quantity = NumberCons.zero;
    this.isLine = StringConst.empty;
    this.isPackage = BooleanCons.false;
    this.isOrderPackage = BooleanCons.false;
    this.userId = StringConst.empty;
    this.cartType = NumberCons.zero;
  }
}

export class MissingProductsInSavedCart {
  itemCode: string;
  description: string;
  constructor() {
    this.itemCode = StringConst.empty;
    this.description = StringConst.empty;
  }
}

export class SendTypeCart {
  cardCode: string;
  cartTypeDestination: number;
  cartTypeSender: number;
  products: Array<ItemCode>;
  constructor() {
    this.cardCode = StringConst.empty;
    this.cartTypeDestination = NumberCons.zero;
    this.cartTypeSender = NumberCons.zero;
    this.products = [];
  }
}

export class DeleteTypeCart {
  userId: string;
  cartType: number;

  constructor() {
    this.userId = StringConst.empty;
    this.cartType = NumberCons.zero;
  }
}

export class ItemCode {
  itemCode: string;
  constructor() {
    this.itemCode = StringConst.empty;
  }
}

export class SaveProductUtility {
  cardCode: string;
  cartType: number;
  products: UtilitySaveItem[];
  priceListId: number;
  clientType: string;
  constructor() {
    this.cardCode = StringConst.empty;
    this.cartType = NumberCons.zero;
    this.products = [];
    this.priceListId = NumberCons.zero;
    this.clientType = StringConst.empty;
  }
}

export class UtilitySaveItem {
  itemCode: string;
  quantity: number;
  container: string;
  label: string;
  constructor() {
    this.itemCode = StringConst.empty;
    this.quantity = NumberCons.zero;
    this.container = StringConst.empty;
    this.label = StringConst.empty;
  }
}

